import React, { FC, useCallback } from 'react';
import Measure from 'react-measure';
import { messaging } from '@factorin/container.macro';
import { useDispatch } from 'react-redux';

import { Box, CloseModalButton, Typography } from 'Modules/ui3';

import { NotificationType } from '../../state/types';
import styles from './index.module.scss';
import { messagingActions } from '../../state/actions';


type NotificationProps = {
    notification: NotificationType;
};

export const Notification: FC<NotificationProps> = ({
    notification: { content, ...notification },
}) => {
    const dispatch = useDispatch();
    const hide = useCallback((notificationId: number) =>
        dispatch(messagingActions.hideMessage(notificationId)), [dispatch]);
    return (
        <Measure bounds>
            {({
                measureRef,
                contentRect: {
                    bounds: { height },
                },
            }) => (
                <Box
                    position='relative'
                    my={2}
                    mr={4}
                    ml={0}
                    height={height}
                    className={styles.notificationContainer}
                >
                    <Box
                        ref={measureRef}
                        position='absolute'
                        top={0}
                        right={0}
                        minWidth='30rem'
                        maxWidth='33vw'
                        py={4}
                        px={8}
                        pl={4}
                        overflow='hidden'
                        textOverflow='ellipsis'
                        borderRadius='0.5rem'
                        sx={{
                            backgroundColor: 'rgba(var(--bg-primary))',
                            boxShadow: '0 0.2rem 0.8rem rgba(var(--bg-secondary-dark), 0.2)',
                        }}
                    >
                        <CloseModalButton
                            size='extraSmall'
                            variant='secondary'
                            onClick={() => hide(notification.id)}
                        />
                        <Typography
                            component='span'
                            fontSize='1.6rem'
                            lineHeight='1.7'
                            fontWeight='300'
                            color='rgba(var(--font-primary))'
                        >
                            {messaging.notificationRenderer
                                ? (
                                    <messaging.notificationRenderer
                                        content={content}
                                    />
                                ) : content }
                        </Typography>
                    </Box>
                </Box>
            )}
        </Measure>
    );
};
